import { ApiError } from "./api";

/**
 * Lo que se le enseña a una persona cuando algo que ESCRIBE no sale.
 *
 * Existe porque un 403 no es una avería y no se puede leer como si lo fuera. `QueryState` ya
 * lo distingue al LEER —candado, tono neutro, «tu sesión está bien»— pero al escribir cada
 * pantalla pintaba en rojo el texto crudo del servidor, así que «no tienes ese permiso» se
 * leía igual que «se cayó la base». Quien lo ve no llama a quien administra los cargos: llama
 * diciendo que el programa está roto.
 *
 * Importa más desde hoy: el backend dejó de exigir el permiso de escribir ruta por ruta y
 * pasó a exigirlo en el montaje, así que **23 rutas que no lo pedían ahora lo piden**. Ningún
 * usuario real pierde nada, pero el 403 va a verse mucho más de lo que se veía.
 *
 * Lo que el servidor sí redacta —los 422 de regla, el 409 del interruptor, el 429 con su
 * cuánto falta— se enseña tal cual: **inventar aquí un mensaje amable para un error que no se
 * entendió manda a corregir el campo equivocado**, y eso es peor que enseñar el técnico.
 */
export function mensajeDe(error: unknown): string {
  if (error instanceof ApiError) {
    // Sé quién eres y esto no te toca. No es un fallo y no se arregla reintentando: se
    // arregla pidiéndoselo a quien reparte los cargos, y eso hay que decirlo.
    if (error.status === 403) {
      return "No tienes permiso para esto. Tu sesión está bien; es que esta acción no entra en tus cargos. Si deberías poder, pídeselo a quien administra el sistema.";
    }
    // No sé quién eres: la sesión se venció mientras se llenaba el formulario.
    if (error.status === 401) {
      return "Tu sesión se venció. Vuelve a entrar y repite lo que estabas haciendo.";
    }
    // Sin red, que el navegador no sabe explicar mejor que esto.
    if (error.status === 0) {
      return "No hay conexión con el servidor. Comprueba la red y vuelve a intentarlo.";
    }
  }
  return error instanceof Error ? error.message : String(error);
}
